export enum TransportationTypes {
  TRUCK = 'flatrate_flatrate',
  SMALL_TRUCK = 'freeshipping_freeshipping',
  SMALL = 'selfpickup_selfpickup',
  EMPTY_SMALL = 'emptiespickup_emptiespickup',
  EMPTY_TRUCK = 'emptiesfulltruck_emptiesfulltruck'
}

export enum OrderTypes {
  TRUCK = 'Full Truck',
  SMALL_TRUCK = 'Half Truck',
  SMALL = 'Self Pickup',
  EMPTY_SMALL = 'EMPTY_SMALL',
  EMPTY_TRUCK = 'EMPTY_TRUCK'
}

export enum SapTransportId {
  YSE1 = 'YSE1',
  YDE1 = 'YDE1',
  YDOR = 'YDOR',
  YSOR = 'YSOR',
  YDER = 'YDER',
  YSER = 'YSER'
}

export function mapTransportType (type: string) {
  const transportMap: { [key: string]: string } = {
    freeshipping_freeshipping: 'Half Truck',
    flatrate_flatrate: 'Full Truck',
    selfpickup_selfpickup: 'Self Pickup',
    emptiesfulltruck_emptiesfulltruck: 'Empty Truck',
    emptiespickup_emptiespickup: 'Empty Small'
  }
  return transportMap[type] || type
}

export function getLocaleKeyForTransportationTypes (transportationTypes: TransportationTypes) {
  let value = ''
  switch (transportationTypes) {
    case TransportationTypes.TRUCK:
      value = 'Transport_Type_Truck'
      break
    case TransportationTypes.SMALL_TRUCK:
      value = 'Transport_Type_Small_Truck'
      break
    case TransportationTypes.SMALL:
      value = 'Transport_Type_Small'
      break
    case TransportationTypes.EMPTY_SMALL:
      value = 'Transport_Type_Empty_Small'
      break
    case TransportationTypes.EMPTY_TRUCK:
      value = 'Transport_Type_Empty_Truck'
      break
    default:
      break
  }
  return value
}

export function getOrderTypeForUnitsConfig (transportationType: TransportationTypes): OrderTypes {
  switch (transportationType) {
    case TransportationTypes.TRUCK:
      return OrderTypes.TRUCK
    case TransportationTypes.SMALL_TRUCK:
      return OrderTypes.SMALL // by definition SMALL_TRUCK should retrieve the same Magento config as SMALL order
    case TransportationTypes.SMALL:
      return OrderTypes.SMALL
    case TransportationTypes.EMPTY_SMALL:
      return OrderTypes.EMPTY_SMALL
    case TransportationTypes.EMPTY_TRUCK:
      return OrderTypes.EMPTY_TRUCK
    default:
      return transportationType
  }
}

export function mapSAPTransportIdToTransportationTypes (sapId: SapTransportId): TransportationTypes {
  switch (sapId) {
    case SapTransportId.YSE1:
      return TransportationTypes.EMPTY_TRUCK
    case SapTransportId.YDE1:
      return TransportationTypes.EMPTY_SMALL
    case SapTransportId.YDOR:
      return TransportationTypes.SMALL
    case SapTransportId.YSOR:
      return TransportationTypes.TRUCK
    case SapTransportId.YDER:
      return TransportationTypes.EMPTY_SMALL
    case SapTransportId.YSER:
      return TransportationTypes.EMPTY_TRUCK
    default:
      return sapId
  }
}
